import { AnchorStyle } from './styles';

type AnchorProps = {
    id: string,
}

export const Anchor = ({ id }:AnchorProps): JSX.Element => {
  return <div id={ id } style={ AnchorStyle.anchor } />;
};
